import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface ReportingEnrollsByClassParams {
  format?: string;
  startDate: string;
  endDate: string;
  includeEvents?: boolean;
}

export const reportingEnrollsByClassAPI = async (
  params?: ReportingEnrollsByClassParams,
) => {
  const response = await baseAPI.get<string>('reporting/enrolls-by-class', {
    params,
    responseType: 'text',
  });
  return response.data;
};

export const useReportingEnrollsByClass = (
  params?: ReportingEnrollsByClassParams,
) => {
  return useQuery({
    queryKey: [KEYS.CLASS_ENROLLMENTS_WITH_STUDENT_DETAILS_REPORT, params],
    queryFn: () => reportingEnrollsByClassAPI(params),
    enabled: !!params?.format && !!params.startDate && !!params.endDate,
  });
};
